// Navigation


$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

// Mobile Navigation

$('.sub-menu-btn-action').on('click', (e) => {
    const el = $(e.currentTarget);
    const icon = el.children('.fa');

    el.siblings('.nav-secondary').toggleClass('active');
    icon.hasClass('fa-chevron-down')
        ? icon.removeClass('fa-chevron-down').addClass('fa-chevron-up')
        : icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');


});

function activateGlide() {
    $('.glide').each(function () {
        const slider = new Glide(".glide", {
            type: "carousel",
            perView: 3,
            keyboard: true,
            breakpoints: {
                992: {
                    perView: 2
                },
                725: {
                    perView: 1
                }
            }
        }).mount();
    });
}

function changeErrMsg() {
    let targetParent = $('.nocaptcha')
    let target;

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

$(document).ready(function () {
    // Testimonial Slider
    if ($('.glide').length) {
        activateGlide();
    }

    // Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }

    // const _screen_watch       = matchMedia("all and (max-width: 767px)");
    // const attrs = function (slideWidth,
    //                         minSlides,
    //                         maxSlides,
    //                         slideMargin,
    //                         adaptiveHeight = true,
    //                         controls = false,
    //                         pager = false,
    // ) {
    //     let attrs = {
    //         slideWidth: slideWidth,
    //         minSlides: minSlides,
    //         maxSlides: maxSlides,
    //         slideMargin: slideMargin,
    //         adaptiveHeight: adaptiveHeight,
    //         controls: controls,
    //         pager: pager
    //     }
    //
    //     !slideWidth ? delete attrs.slideWidth : '';
    //
    //     return attrs;
    //
    // };
    //
    // let _attrs_slide_desktop    = attrs(400,1,3,40);
    // let _attrs_slide_mobile     = attrs(false,1,0,0)
    // let _screen                 = window.matchMedia("(max-width: 992px)").matches;
    //
    //
    // const _testimonial_slider = $('.testimonials__slider').bxSlider( _screen
    //                                                                         ? _attrs_slide_mobile
    //                                                                         : _attrs_slide_desktop
    //                                                                 );
    //
    //
    // if( _testimonial_slider.length > 0 ) {
    //     window.addEventListener('resize', function(event) {
    //         let _screen                 = window.matchMedia("(max-width: 992px)").matches;
    //         _testimonial_slider.stopAuto(true);
    //         _testimonial_slider.reloadSlider( _screen
    //                                             ? _attrs_slide_mobile
    //                                             : _attrs_slide_desktop);
    //     }, true);
    // }
    //
    //
    //
    // $('.bx-custom-next').on('click', function() {
    //    _testimonial_slider.goToNextSlide()
    // })
    //
    // $('.bx-custom-prev').on('click', function() {
    //     _testimonial_slider.goToPrevSlide()
    // })


    // NewsLetter : Add new subscription


    $('#email-form').submit(function (e) {

        e.preventDefault();

        var form = $(this)
        var formData = form.serialize();

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: formData,
            dataType: 'json',

            beforeSend: function () {

                $('.uui-text-span').css('opacity', 0);
                $('.loading ').css({'opacity': 1});
            },

            success: function (response) {

                $('.message-form').html(response.message)
                form[0].reset();
                $('.uui-text-span').css('opacity', 1)
                $('.loading ').css({'opacity': 0});


                if (response.success) {
                    $('.message-form').css({"color": "#91cfa8"})
                } else {
                    $('.message-form').css({"color": "#fe8686"})
                }

            },
            error: function () {
                console.error('Error en la solicitud');
            }
        });
    });

    let arrow = $('.arrow-bg');

    if (arrow.length) {
        arrow.on('click', function () {

            var scrollAmount = $('article .content .element').eq(1).offset().top - $(window).scrollTop();

            $('html, body').animate({
                scrollTop: '+=' + scrollAmount
            }, 600);
        });
    }
});
